import XLSX from 'sheetjs-style';
import {excelHeaderCellsRange} from '../constants/excelHeaderCellsRange';

const set_right_to_left = wb => {
  if (!wb.Workbook) wb.Workbook = {};
  if (!wb.Workbook.Views) wb.Workbook.Views = [];
  if (!wb.Workbook.Views[0]) wb.Workbook.Views[0] = {};
  wb.Workbook.Views[0].RTL = true;
};

const fit_to_column = (data) => {
  const columnWidths = [];
  for (const i in data[0]) {
    columnWidths.push({
      wch: Math.max(
        i ? i.toString().length : 5,
        ...data.map(obj => obj[i] ?  obj[i].toString().length : 5),
        )});
  }
  return columnWidths;
};

const style_header_cells_bold = (headersArray, ws) => {
  headersArray.map(item => {
    if (ws[item]) {
      return ws[item].s = {
        font: {
          bold: true,
        },
        alignment: {
          horizontal: 'center'
        }
      }
    } else return null
  });
};

const style_cells_content_center = (headersArray, ws) => {
  Object.keys(ws).forEach(cell => {
    if (
      cell.startsWith('!') ||        // skip worksheet metadata
      headersArray.includes(cell) || // skip header cells
      !ws[cell] ||
      ws[cell].t === undefined        // not a real cell
    ) {
      return;
    }

    ws[cell].s = {
      ...(ws[cell].s || {}),
      alignment: {
        horizontal: 'center',
      },
    };
  });
};

export const generateExcelFile = (sheets, fileName) => {
  /* build new workbook */
  const wb = XLSX.utils.book_new();

  sheets.forEach(({ data, title }) => {
    /* create new worksheet from data and static title */
    const ws = XLSX.utils.json_to_sheet([{title},],
      { skipHeader: true, origin: 'A1' },
    );

    XLSX.utils.sheet_add_json(ws, data, { origin: 'A1' });

    ws['!cols'] = fit_to_column(data);

    style_header_cells_bold(excelHeaderCellsRange, ws);
    style_cells_content_center(excelHeaderCellsRange, ws);
    /* append worksheet */
    XLSX.utils.book_append_sheet(wb, ws);
  });

  set_right_to_left(wb);

  /* write file */
  XLSX.writeFile(wb, fileName);
};
